import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Typography,
} from "@mui/material";

/**
 * Loading state for table body
 */
export const TableLoadingState = ({ colSpan = 8 }) => (
  <TableBody sx={{ margin: "auto", width: "100%", border: "none" }}>
    <TableRow sx={{ border: "none" }}>
      <TableCell colSpan={colSpan} align="center">
        <CircularProgress style={{ margin: "auto" }} />
      </TableCell>
    </TableRow>
  </TableBody>
);

/**
 * Empty state for table body
 */
export const TableEmptyState = ({ colSpan = 8, message = "No Orders Found" }) => (
  <TableBody>
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Typography
          sx={{
            fontSize: "1.5rem",
            fontWeight: 500,
            color: "#61616F",
          }}
        >
          {message}
        </Typography>
      </TableCell>
    </TableRow>
  </TableBody>
);